<p>edit-registro works!</p>
